import { Flex } from 'antd';
import { t } from 'i18next';

import ReportChart from 'business/shift-report/report/components/ReportChart';
import { GetShiftReportPdfMetadataQuery } from 'generated/graphql';
import { useMediaType } from 'technical/media/hooks';

import { MobileCardHeader } from './mobile-header';

type ReportChartContainerProps = {
  report: NonNullable<GetShiftReportPdfMetadataQuery['shiftReport']>;
  nbRingsBuild: number;
  activities: GetShiftReportPdfMetadataQuery['activities'];
};

export const ReportChartContainer = ({
  report,
  nbRingsBuild,
  activities,
}: ReportChartContainerProps) => {
  const { isMobile } = useMediaType();
  const nbTasks = report.tasks.length;
  const startRing = report.tasks[0]?.ring ?? 0;
  const endRing = report.tasks[nbTasks - 1]?.ring ?? 0;

  return (
    <div className="bloc with-page-break" key="chart">
      {isMobile ? (
        <Flex vertical>
          <MobileCardHeader>
            {t('pages.print.ringTitle', {
              startRing,
              endRing,
              count: nbRingsBuild,
              context: nbRingsBuild > 0 ? 'withTotal' : undefined,
            })}
          </MobileCardHeader>
          <MobileCardHeader>
            {t('pages.print.distanceTitle', {
              startMetricPoint: report.startMetricPoint,
              endMetricPoint: report.endMetricPoint,
              distanceUnit: report.constructionSite.distanceUnit,
              context:
                !report.operatorValidation || !report.endMetricPoint
                  ? 'inProgress'
                  : null,
            })}
          </MobileCardHeader>
        </Flex>
      ) : (
        <h1>
          <span>
            {t('pages.print.ringTitle', {
              startRing,
              endRing,
              count: nbRingsBuild,
              context: nbRingsBuild > 0 ? 'withTotal' : undefined,
            })}
          </span>
          <span>
            {t('pages.print.distanceTitle', {
              startMetricPoint: report.startMetricPoint,
              endMetricPoint: report.endMetricPoint,
              distanceUnit: report.constructionSite.distanceUnit,
              context:
                !report.operatorValidation || !report.endMetricPoint
                  ? 'inProgress'
                  : null,
            })}
          </span>
        </h1>
      )}
      <ReportChart
        shift={report.shift}
        date={report.date}
        activities={activities}
        tasks={report.tasks}
        criticalPathValid={false}
        mode="view"
      />
    </div>
  );
};
